import { useEffect, useState } from 'react';

import { useApiClient } from '@eluve/api-client-provider';
import { ConversationStarters, SettingsPageFrame } from '@eluve/blocks';
import { LoadingIndicator, Stack } from '@eluve/components';
import { useIsPostHogFeatureFlagEnabled } from '@eluve/posthog-react';

import { useChatSettings } from './useChatSettings';

export const ChatConversationStartersPage = () => {
  const {
    tenantId,
    conversationStarters,
    isLoadingDefaults,
    availablePreferences,
    saveConversationStarters,
  } = useChatSettings();
  const apiClient = useApiClient();

  const specTemplatesEnabled = useIsPostHogFeatureFlagEnabled(
    'CHAT_SPEC_TEMPLATES',
  );
  const [specTemplates, setSpecTemplates] = useState<
    Array<{ id: string; name: string; description: string | null }>
  >([]);

  useEffect(() => {
    if (!specTemplatesEnabled) return;
    const fetchSpecTemplates = async () => {
      const result = await apiClient.mastra.getSpecTemplates({
        params: { tenantId },
      });
      if (result.status === 200) {
        setSpecTemplates(result.body.templates);
      }
    };
    fetchSpecTemplates();
  }, [apiClient, tenantId, specTemplatesEnabled]);

  return (
    <SettingsPageFrame
      title="Conversation Starters"
      parentTitle="Chat Preferences"
      backTo=".."
    >
      {isLoadingDefaults ? (
        <Stack
          className="rounded-lg border border-border-primary bg-bg-secondary p-10"
          direction="horizontal"
          align="center"
          justify="center"
        >
          <LoadingIndicator />
        </Stack>
      ) : (
        <ConversationStarters
          initialStarters={conversationStarters}
          onSave={saveConversationStarters}
          availablePreferences={availablePreferences}
          availableSpecTemplates={
            specTemplatesEnabled
              ? specTemplates.map((t) => ({
                  id: t.id,
                  label: t.name,
                }))
              : undefined
          }
        />
      )}
    </SettingsPageFrame>
  );
};
